export default __webpack_public_path__ + "static/media/longchamp5.8cc23681.jpg";